<template>
    <div class="aba-cliente">
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="vertical-flow">
            <div class="columns">
                <div
                    class="column"
                    :class="[
                        permissaoVincular && permissaoCadastrar
                            ? 'is-4'
                            : permissaoVincular || permissaoCadastrar
                            ? 'is-6'
                            : 'is-8',
                    ]"
                >
                    <search-bar
                        :onSearch="debouncedOnSearch"
                        tooltipLabel="msg-campo-busca-transportadora"
                    />
                </div>

                <div
                    class="column"
                    :class="[
                        permissaoVincular && permissaoCadastrar
                            ? 'is-2'
                            : permissaoVincular || permissaoCadastrar
                            ? 'is-3'
                            : 'is-4',
                    ]"
                >
                    <vss-select
                        ref="situacaoSelect"
                        :searchable="false"
                        :options="situacaoSelect"
                        v-model="situacaoSelected"
                        mlLabels
                        title="situacao"
                        clearable
                        @input="onSituacaoChanged"
                        :height="40"
                    />
                </div>

                <div class="column is-3" v-if="permissaoVincular">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="showModalVincularTransportadora"
                    >
                        {{ $t('vincular-transportadora') }}
                    </button>
                </div>

                <div class="column is-3" v-if="permissaoCadastrar">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="
                            $router.push({
                                name: `${abrev}-transportadora-new`,
                                query: {
                                    tela: 'cliente-transportadora',
                                    id: $route.params.id,
                                    name: $route.params.name,
                                    dadoscadastrais: 6,
                                    politicacomercial: $route.query.politicacomercial
                                        ? $route.query.politicacomercial
                                        : null,
                                    analisecomercial: $route.query.analisecomercial
                                        ? $route.query.analisecomercial
                                        : null,
                                },
                            })
                        "
                    >
                        {{ $t('adicionar-transportadora') }}
                    </button>
                </div>
            </div>

            <div class="registry-wrapper">
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="assClienteTransportadora"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="f.key != 'excluir' ? $t(f.key) : ''"
                        :width="f.width"
                        :class="{
                            'excluir-field': f.key == 'excluir',
                        }"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        v-slot="props"
                    >
                        <div v-if="f.key == 'excluir'">
                            <b-button
                                v-if="permissao.update && !assClienteTransportadoraIntegracao"
                                class="action-button"
                                :type="
                                    props.row['replicapda'] == 3
                                        ? 'is-danger'
                                        : 'is-success'
                                "
                                :icon-right="
                                    props.row['replicapda'] == 3 ? 'delete' : 'check'
                                "
                                @click="promptChangeSituacao(props.row)"
                                v-tippy 
                                :title="$t(props.row['replicapda'] == 3 ? 'desativar' : 'reativar')"
                            />
                        </div>
                        <div v-else-if="f.key == 'replicapda'">
                            <b-tag
                                class="table-tag table-tag-full-width"
                                :type="props.row['replicapda'] == 3 ? 'is-success' : 'is-danger'"
                                size="is-medium"
                            >
                                {{ $t(props.row['replicapda'] == 3 ? 'ativo' : 'inativo') }}
                            </b-tag>
                        </div>
                        <div v-else-if="f.key == 'cnpj' || f.key == 'cep'">
                            <HideInfo
                                v-if="!cleanHide"
                                :value="props.row[f.key]"
                                :hideInfo="hide.hideInfo"
                                :infoIsHidden="hide.infoIsHidden"
                                showPartInfoPosition="end"
                                :showPartInfoLenght="4"
                            />
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>

            <!-- MODAL DE ASSOCIACAO -->
            <b-modal :active.sync="showModalAssociacao">
                <div class="bg">
                    <TransportadoraModal
                        :idCliente="$route.params.id"
                        :permissaoVincular="!assClienteTransportadoraIntegracao"
                        @fecharModal="fecharModal"
                    />
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
// SERVICES
import AssClienteTransportadoraService from '@/services/vendas/cliente/abas/AssClienteTransportadoraService';
import TransportadoraModal from '@/components/vendas/cliente/modal/TransportadoraModal.vue';

// COMPONENTS
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import HideInfo from '@/components/shared/HideInfo';
import { mapState } from 'vuex';

export default {
    components: {
        ContainerLoader,
        TransportadoraModal,
        HideInfo,
    },
    data() {
        return {
            cleanHide: true,
            assClienteTransportadoraIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'ASSCLIENTETRANSPORTADORA'
            ),
            transportadora: this.$store.state.user.tabelasERPWebServer.includes('TRANSPORTADORA'),
            assClienteTransportadora: [],
            fields: [
                {
                    key: 'idassclientetransportadora',
                    width: null,
                    sortable: false,
                    sortFn: null,
                },
                {
                    key: 'codigo',
                    width: null,
                    sortable: false,
                    sortFn: null,
                },
                { key: 'cnpj', width: null, sortable: false, sortFn: null },
                { key: 'nome', width: null, sortable: true, sortFn: null },
                { key: 'endereco', width: null, sortable: false, sortFn: null },
                { key: 'bairro', width: null, sortable: false, sortFn: null },
                { key: 'cep', width: null, sortable: false, sortFn: null },
                { key: 'replicapda', width: 80, sortable: false, sortFn: null },
                { key: 'excluir', width: 20, sortable: false, sortFn: null },
            ],
            service: new AssClienteTransportadoraService(this.$http, this.$router),
            permissao: false,
            permissaoUsuario: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            situacaoSelected: { id: 4, label: 'todos' },
            situacaoSelect: [
                { id: 4, label: 'todos' },
                { id: 3, label: 'ativos' },
                { id: 2, label: 'inativos' },
            ],
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: '',
            column: 'nome',
            order: 'asc',
            isSaving: false,
            delete: null,
            showModalAssociacao: false,
            permissaoCadastroTransportadora: false,

            //permissoes relativas à exibição dos botões
            permissaoVincular: false,
            permissaoCadastrar: false,

            // @86308 - Rota dinâmica abreviando o contexto
            abrev: this.$route.meta.contexto.slice(0, 3),
            isVenda: this.$route.meta.contexto == 'vendas',
            isAgro: this.$route.meta.contexto == 'agro',
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        if (this.isVenda) {
            this.permissao = this.hasPermissionAccess(
                'vendas',
                'clientes',
                'ven-cliente-dados-cadastrais-transportadora'
            );
        } else if (this.isAgro) {
            this.abrev = this.$route.meta.contexto.slice(0, 4);
            this.permissao = this.hasPermissionAccess(
                'agro',
                'clientes',
                'agro-cliente-dados-cadastrais-transportadora'
            );
        }

        if (this.isVenda) {
            this.permissaoCadastroTransportadora = this.hasPermissionAccess(
                'vendas',
                'clientes',
                'ven-transportadora'
            );
        } else if (this.isAgro) {
            this.abrev = this.$route.meta.contexto.slice(0, 4);
            this.permissaoCadastroTransportadora = this.hasPermissionAccess(
                'agro',
                'clientes',
                'agro-transportadora'
            );
        }

        this.permissaoVincular = this.permissao.create && !this.assClienteTransportadoraIntegracao;
        this.permissaoCadastrar =
            this.permissaoCadastroTransportadora.create && !this.transportadora;

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'clientes' },
            });
        } else {
            this.carregarDados();
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        }
    },
    computed: {
        ...mapState(['hide']),
    },
    methods: {
        infoIsHidden() {
            this.$store.dispatch('infoIsHidden', { infoIsHidden: !this.hide.infoIsHidden });
        },
        carregarDados(currentPage = 1) {
            this.cleanHide = true;
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            this.findAll(
                this.column,
                this.order,
                currentPage - 1,
                this.pagination.perPage,
                this.situacaoSelected.id,
                this.$route.params.id,
                this.queryFilter
            )
                .then(this.mapItems)
                .then((value) => {
                    this.assClienteTransportadora = value;
                    this.isEmpty = this.assClienteTransportadora.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar as transportadoras!');
                })
                .finally((_) => {
                    this.cleanHide = false;
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        findAll(column, order, page, limit, situacao, id, ...params) {
            if (this.isVenda) {
                return this.service.findAllVendas(
                    column,
                    order,
                    page,
                    limit,
                    situacao,
                    id,
                    ...params
                );
            } else {
                return this.service.findAllAgro(
                    column,
                    order,
                    page,
                    limit,
                    situacao,
                    id,
                    ...params
                );
            }
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    idassclientetransportadora: m.id,
                    codigo: m.idassclientetransportadoraerp,
                    idtransportadora: m.idtransportadora,
                    cnpj: m.transportadora.cnpj,
                    nome: m.transportadora.nome,
                    endereco: m.transportadora.endereco,
                    bairro: m.transportadora.bairro,
                    cep: m.transportadora.cep,
                    replicapda: m.replicapda,
                    excluir: 'excluir',
                };
            });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSituacaoChanged(val) {
            this.situacaoSelected = val
                ? this.situacaoSelect.filter((v) => v.id == val.id)[0]
                : this.situacaoSelect[0];
            this.carregarDados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.replicapda == 3
                        ? 'msg-confirmacao-desativacao-n'
                        : 'msg-confirmacao-reativacao-n', 
                    { n: row['nome'] }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.delete.replicapda == 3
                    ? 'msg-erro-ao-desativar-associacao-cliente-transportadora'
                    : 'msg-erro-ao-reativar-associacao-cliente-transportadora';

            let tempAssClienteTransportadora = {
                idassclientetransportadora: this.delete.idassclientetransportadora,
                replicapda: this.delete.replicapda == 3 ? 2 : 3,
            };

            this.isLoading = true;

            this.updateSituacao(tempAssClienteTransportadora)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess =
                            r.content.replicapda == 3
                                ? 'msg-sucesso-ao-reativar-associacao-cliente-transportadora'
                                : 'msg-sucesso-ao-desativar-associacao-cliente-transportadora';
                        this.$root.showMessage('success', tempSuccess);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', tempFailure);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        updateSituacao(assClienteTransportadora) {
            if (this.isVenda) return this.service.updateSituacaoVendas(assClienteTransportadora);
            else return this.service.updateSituacaoAgro(assClienteTransportadora);
        },
        showModalVincularTransportadora() {
            this.showModalAssociacao = !this.showModalAssociacao;
        },
        fecharModal() {
            this.showModalAssociacao = false;
            this.carregarDados();
        },
    },
};
</script>

<style lang="scss" scoped>
.aba-cliente {
    height: 100%;

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    @media (max-width: 760px) {
        .search-bar {
            padding-bottom: 0.4rem;
        }
        .botao-acao {
            margin-top: 0;
        }
    }
}
</style>
